module.exports = __webpack_public_path__ + "images/thumbs-downdd5a651a06aa80d45e76890fe644d54e.svg";